module.exports = __webpack_public_path__ + "img/dissatisfied_gray.0962de71.png";